import { render, staticRenderFns } from "./TaskDeviceModal.vue?vue&type=template&id=596c36c2&scoped=true&"
import script from "./TaskDeviceModal.vue?vue&type=script&lang=js&"
export * from "./TaskDeviceModal.vue?vue&type=script&lang=js&"
import style0 from "./TaskDeviceModal.vue?vue&type=style&index=0&id=596c36c2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "596c36c2",
  null
  
)

export default component.exports